// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__1OHZV","ScrollX":"Scroll_ScrollX__1LuQH","ScrollY":"Scroll_ScrollY__3Spt1"};